import './App.css';
import React from 'react';
import Router from './Router';
import FootBar from './component/FootBar/FootBar';
import { makeStyles } from '@material-ui/core/styles';
import withClearCache from './ClearCache';
import { Button } from '@material-ui/core';
import { api } from "./redux/config";
import { connect } from "react-redux";
import * as actionTypesModal from './redux/action/modalAction';
// import { Detector } from "react-detect-offline";
import NetworkDetector from './NetworkDetect';
import moment from "moment";

const ClearCacheComponent = NetworkDetector(withClearCache(MainApp));

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
    overflow: 'hidden',
    display: ' block',
    position: 'relative'
  },
  app: {
    [theme.breakpoints.down('xs')]: {
      paddingBottom: '520px'
    },
    paddingBottom: '330px',
    height: '100%',
    position: 'relative'
  },
  footer: {
    position: 'absolute',
    bottom: 0,
    width: '100%'
  }
}));


const timeStart = (start_date) => {
  // format (YYYY-MM-DD HH:mm:ss)

  var new_start_date = moment(start_date).format('YYYY-MM-DD HH:mm:ss');

  return new_start_date.split(' ')[1].split(':')[0]+new_start_date.split(' ')[1].split(':')[1] //jam + minutes

}


const timeReminder = (start_date) => {
  // format (YYYY-MM-DD HH:mm:ss)
  var minutes = 10;

  var reminder = moment(start_date).subtract(minutes, 'minutes').format('YYYY-MM-DD HH:mm:ss');

  return reminder.split(' ')[1].split(':')[0]+reminder.split(' ')[1].split(':')[1] //jam + minutes

}

const convertNewDate = () => {
  
  const format1 = "YYYY-MM-DD HH:mm:ss"
  let date1 = new Date();
  let hours = date1.getHours()

  let dateTime1 = moment(date1).format(format1);

  return hours + dateTime1.split(' ')[1].split(':')[1] //jam + minutes

}



function App({ showModalAction }) {

  React.useEffect(() => {
    //handleResetStorage
    var hours = 1; // Reset when storage is more than 24hours
    var now = new Date().getTime();
    var setupTime = localStorage.getItem('setupTime');
    if (setupTime == null) {
        console.log("not login")
    } else {
        if(now-setupTime > hours*60*60*1000) {
            localStorage.clear()
            localStorage.setItem('setupTime', now);
        }
    }
    //end

    if (navigator.userAgent.indexOf(' UCBrowser/') >= 0) {
      setInterval(function(){ 
        showModalAction({
          title:'Pengumuman',
          body: <p>Anda tidak bisa mengakses menggunakan UC browser. Silahkan Menggunakan Google Chrome, Safari, Firefox atau browser bawaan di HP anda</p>
        })
       }, 300);
      }

    if(sessionStorage.firstLogin){
      console.log("done first login")
    } else {
      sessionStorage.setItem('firstLogin', true)

      // setDate()

      api.get(`/setting/get-maintenance-status`)
        .then(response => {
          // // console.log(response)
          // // temp = response
          // if(response.data.data.maintenance.is_maintenance === 1 ){

          //   // if( '47' === '47'){
          //     if( convertNewDate() >= timeReminder(response.data.data.maintenance.start_at) && convertNewDate() <= timeStart(response.data.data.maintenance.start_at)){
          //       // if( convertNewDate() === timeReminder(response.data.data.maintenance.start_at)){
              
          //         showModalAction({
          //           title:'Pengumuman',
          //           body:<>
          //            'Segala aktifitas tidak akan di record oleh system 10 menit dari sekarang, mohon untuk dapat menyelesaikan semua aktifitas sebelum jam tersebut'
          //           </>
          //         })

          //   }
          //   // else{
          //   else if(convertNewDate() >= timeStart(response.data.data.maintenance.start_at)){
  
     

          //         setInterval(function(){ 
          //           showModalAction({
          //             title:'Pengumuman',
          //             body: <React.Fragment>
          //                     <div dangerouslySetInnerHTML={{ __html: response.data.data.maintenance.message.replace(`../../`, process.env.REACT_APP_MAIN_URL_ASSETS).replace(`../../`, process.env.REACT_APP_MAIN_URL_ASSETS).replace(`../`, process.env.REACT_APP_MAIN_URL_ASSETS).replace(`../`, process.env.REACT_APP_MAIN_URL_ASSETS)}}/>
          //                   </React.Fragment>
          //           })
                
          //          }, 3000);
            
  
          //   }




          // }

          if(response.data.data.maintenance.is_maintenance === 1 ){
            showModalAction({
                title:'Pengumuman',
                body: <React.Fragment>
                        <div dangerouslySetInnerHTML={{ __html: response.data.data.maintenance.message.replace(`../../`, process.env.REACT_APP_MAIN_URL_ASSETS).replace(`../../`, process.env.REACT_APP_MAIN_URL_ASSETS).replace(`../`, process.env.REACT_APP_MAIN_URL_ASSETS).replace(`../`, process.env.REACT_APP_MAIN_URL_ASSETS)}}/>
                      </React.Fragment>
              })
          }
        })
        .catch(response => {
            // console.log(response)
            // if(response.response && response.response.status === 503){
            //     showModalAction({
            //         title: 'Maintenance',
            //         body: response.response.data.error.message,
            //         relog: true
            //     });
            // }
            if(response.response && response.response.status === 401){
                showModalAction({
                    title: 'Sesi Habis',
                    body: 'Sesi anda habis, silahkan login ulang',
                    relog: true
                });
            }
        })
    } 

    if(sessionStorage.popUpLogin){
      console.log("done popup")
    } else {
      api.get(`/setting/get-popup-status`)
      .then(response => {
        sessionStorage.setItem('popUpLogin', true)
        if(response.data.data.maintenance.is_maintenance === 1 ){
          showModalAction({
            title:'Pengumuman',
            body: <React.Fragment>
                    <div dangerouslySetInnerHTML={{ __html: response.data.data.maintenance.message.replace(`../../`, process.env.REACT_APP_MAIN_URL_ASSETS).replace(`../../`, process.env.REACT_APP_MAIN_URL_ASSETS).replace(`../`, process.env.REACT_APP_MAIN_URL_ASSETS).replace(`../`, process.env.REACT_APP_MAIN_URL_ASSETS)}}/>
                    <div style={{textAlign: 'center'}}><Button color="primary" variant="contained" onClick={() => window.location.assign(response.data.data.maintenance.link)}>Klik untuk ikut Kompetisi</Button></div>
                  </React.Fragment>
          })
          }
        })
        .catch(response => {
            if(response.response && response.response.status === 401){
                showModalAction({
                    title: 'Sesi Habis',
                    body: 'Sesi anda habis, silahkan login ulang',
                    relog: true
                });
            }
        })
    } 
  }, [])

  return (
    <ClearCacheComponent offline={false} />
  );
}



function MainApp() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.app}>
        <Router />
      </div>
      <div className={classes.footer}>
        <FootBar />
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    showModalAction: (object) => dispatch(actionTypesModal.showModalAction(object)),
  }
}

export default connect(null, mapDispatchToProps)(App);
